export const ServiceHost = 'https://service.hummau.xyz/api'